import { ShipperContractCreatePage } from "@/pages/shipper-contract-create";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/shipper/delivery-proposals/$id/contracts/create",
)({
  component: () => {
    const { id } = useParams({ strict: false });
    return <ShipperContractCreatePage deliveryProposalOfferCargoIdStr={id} />;
  },
});
